import React from 'react'
import { Box, DialogTitle, IconButton, Tooltip } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

// "<Tool> · <sample>" title with a close button, shared by the sample tool
// dialogs opened from the Home analysis table.
const SampleToolDialogTitle = ({ title, sampleName, onClose, disableClose = false }) => (
  <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 2, pr: 2 }}>
    <Box component="span" sx={{ flexGrow: 1, minWidth: 0, overflowWrap: 'anywhere' }}>
      {sampleName ? `${title} · ${sampleName}` : title}
    </Box>
    <Tooltip title="Close" arrow>
      <span>
        <IconButton size="small" onClick={onClose} disabled={disableClose} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  </DialogTitle>
)

export default SampleToolDialogTitle
